import { inject, Injectable } from '@angular/core';
import { RecaptchaService } from '@principle-theorem/ng-shared';
import {
  type IInvoiceWithProviderDetails,
  IPatientViewInvoiceRequest,
  PATIENT_PORTAL_DISPATCHER,
  PatientAction,
  PatientActionRequest,
} from '@principle-theorem/principle-core/interfaces';
import {
  httpsCallable,
  type SerialisedData,
  snapshot,
  unserialise,
} from '@principle-theorem/shared';

@Injectable()
export class PatientViewInvoiceService {
  private _recaptcha = inject(RecaptchaService);

  async resolveInvoice(
    tokenUid: string
  ): Promise<IInvoiceWithProviderDetails | undefined> {
    try {
      const recaptchaToken = await this._recaptcha.execute(
        PatientAction.GetPatientInvoice
      );
      const payload = {
        action: PatientAction.GetPatientInvoice,
        data: { tokenUid },
        recaptchaToken,
      };
      const response = await snapshot(
        httpsCallable<
          PatientActionRequest<IPatientViewInvoiceRequest>,
          SerialisedData<IInvoiceWithProviderDetails>
        >(PATIENT_PORTAL_DISPATCHER)(payload)
      );
      return unserialise<IInvoiceWithProviderDetails>(response);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error resolving invoice:', error);
      return undefined;
    }
  }
}
